module.exports = __webpack_public_path__ + "worker.cc9ab7896d5a6aa21b63.worker.js"